import { adaptTargetDeliveryTemplatesMap } from './targetDeliveryTemplateAccessFunction.adapter';
import * as types from './targetDeliveryTemplateAccessFunction.types';

export const initialState: types.TargetDeliveryTemplateAccessFunctionState = {
  entities: [],
  selected: [],
  targetDeliveryTemplatesMap: {},
  single: null,
  createdId: null,
  ui: {
    isCreatePopupOpen: false,
    isLoading: false,
  },
};

export default function targetDeliveryTemplateAccessFunctionReducer(
  state = initialState,
  action: types.TargetDeliveryTemplateAccessFunctionActionTypes,
): types.TargetDeliveryTemplateAccessFunctionState {
  switch (action.type) {
    case types.GET_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_LIST:
      return {
        ...state,
        selected: [],
      };

    case types.GET_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_LIST_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data ?? [],
        targetDeliveryTemplatesMap: adaptTargetDeliveryTemplatesMap(action.payload.data.data || []),
        selected: [],
      };

    case types.GET_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_PENDING:
      return {
        ...state,
        single: null,
      };

    case types.GET_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_FULFILLED:
      return {
        ...state,
        single: (action.payload.data.data ?? [])[0],
      };

    case types.SELECT_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION:
      return {
        ...state,
        selected: action.payload || [],
      };

    case types.CREATE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_PENDING:
      return {
        ...state,
        createdId: null,
      };

    case types.CREATE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_FULFILLED:
      return {
        ...state,
        createdId: action.payload.data.metadata?.idCreated ?? null,
      };

    case types.DELETE_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_FULFILLED:
      return {
        ...state,
        selected: [],
      };

    case types.SET_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION_LOADING:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };

    default:
      return state;
  }
}
